// client.ts
import { treaty } from "@elysia/eden";
import type { API } from "../../api/";

export const api = treaty<API>(window.location.host).api;
